<button type="button" class="header" [attr.aria-expanded]="!collapsed()" (click)="toggleCollapse.emit()">
    <span>{{ label() }}</span>
    <app-icon name="chevron-down" class="chevron" [class.collapsed]="collapsed()" />
</button>
